import { BASE_URL } from '../../../Constant';

export const API_CREATE_ARTICLE_TRANSLATION: string = `${BASE_URL}/article/translation`;
export const API_EDITOR_IMAGE_UPLOAD: string = `${BASE_URL}/article/editorFileUpload`;

export const API_UPDATE_ARTICLE_TRANSLATION: string = `${BASE_URL}/article/translation/update`;
export const GET_SINGLE_ARTICLE_TRANSLATION = (
    articleId: number,
    languageId: number,
): string => `${BASE_URL}/article/translation/${articleId}/${languageId}`;
export const API_IS_URL_EXISTS_ARTICLE: string = `${BASE_URL}/article/isUrlExist`;
